export default "__VITE_ASSET__F0E5Pafk__"